import React, { Component } from 'react'
import { Button, Col, Row, MenuItem, Dropdown } from 'react-bootstrap'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faChevronLeft, faEllipsisH, faLink } from '@fortawesome/free-solid-svg-icons'
import { end_point, getParams } from '../helper'
import HamburgerNavbar from '../hamburgerNavbar'
import axios from 'axios'
import moment from 'moment'

class MasterBroadcast extends Component {
  constructor(props) {
    super(props)
    this.state = {
      token: getParams().jwt,
      program: null,
      program_id: getParams().program_id,
      program_name: getParams().program_name.replace(/%20/g, " ").replace(/%27/g, "'"),
      organization_id: localStorage.getItem("organization_id"),
      //userType: getParams().type,
      sessions: null,
      coaches: null,
    }
  }

  componentDidMount() {
    const { token, organization_id } = this.state
    //get program VT sessions
    axios.get(`${end_point('programs')}/programs`, {
      headers: {
        "token": token,
        "organization_id": organization_id,
        "program_id": this.state.program_id
      },
    }).then(response => {
      console.log("Program:", response.data.message[0])
      this.setState({
        program: response.data.message[0],
        sessions: response.data.message[0].VTsessions
      })
    })

    axios.get(`${end_point('users')}/users`, {
      headers: {
        "token": token,
        "organization_id": organization_id,
        "user_type": "coachadmin"
      },
    }).then(data => {
      this.setState({ coaches: data.data.message })
    })
  }

  render() {
    const { sessions, coaches, program_name, program } = this.state
    
    return (
      <div>
        <HamburgerNavbar />
        <div className="body-wrapper" style={{padding: '1%'}}>
          <a className="roster-btn" href={window.location.origin + "/broadcastMaster?jwt=" + this.state.token}>
            <FontAwesomeIcon icon={faChevronLeft} style={{fontSize: "1.2em", marginTop: '2px'}} className="pull-left" color='#fc6723'/>
            <span className="back-to-rosters">BACK TO VIRTUAL TRAINING</span>
          </a>
          <h2 className="white-text">Virtual Training Session</h2>
          <Row className="white-text" style={{width: "100vw"}}>
            <Col sm={5}>
              { program &&
                <h4>{program.ages} {program.division} {program_name}</h4>
              }
            </Col>
            <Col sm={1} className="pull-right right-btns">
              <Dropdown id="ellipsis-dropdown">
                <Dropdown.Toggle as={this.customToggle} className="ellipsis-dropdown pull-right" id="dropdown-custom-components">
                  <a><FontAwesomeIcon icon={faLink} style={{fontSize: "2.5em", width: '1em'}} color='#fc6723'/></a>
                </Dropdown.Toggle>
                <Dropdown.Menu className="team-ellipsis-menu test-left">
                <MenuItem className="li-item" href={window.location.origin + "/notifications?jwt=" + this.state.token + "&organization_id=" + this.state.organization_id + "&program_id=" + this.state.program_id + "&broadcasts=" + true}>
                    Send links to participants
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
          <div className="vt-board" style={{marginLeft: '0'}}>
            {  
              sessions && sessions.length > 0 && coaches &&
              sessions.map(session => {
                let date = moment(session.date).format("MMMM-DD-YYYY")
                let coach = coaches.find(coach => coach._id === session.coach)
                return <div className="vt-list">
                    <Dropdown className="pull-right" id="vt-dropdown">
                      <Dropdown.Toggle as={this.customToggle} className="ellipsis-dropdown" id="dropdown-custom-components">
                        <a><FontAwesomeIcon icon={faEllipsisH} size="2x" color='white' className="team-ellipsis" /></a>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="ellipsis-menu">
                        <MenuItem className="li-item" onClick={() => this.sendToNotifications()}>
                          Send links to participants
                        </MenuItem>
                      </Dropdown.Menu>
                    </Dropdown>
                  <div className="vt-info">
                    <h4 className="white-text" style={{marginTop: '0'}}>{session.name}</h4>
                    <div style={{textAlign:'left', marginLeft: "0.5em"}}>
                      <p className="white-text">Date: {date}</p>
                      <p className="white-text">Coach: {`${coach.first_name} ${coach.last_name}`}</p>
                      <p className="white-text">Start Time: {session.start_time}</p>
                      <p className="white-text">End Time: {session.end_time}</p>
                    </div>
                    <Button target="_blank" className="orange-fill VT-btn" href={`${session.link}&organization_id=${this.state.organization_id}&jwt=${this.state.token}`}>
                      START
                    </Button>
                  </div>
                </div>
              })
            }
            </div>
        </div>
      </div>
    )
  }
}

export default MasterBroadcast
